var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.displayViewCounterMessage
    ? _c("ob1-message-alerte", {
        staticClass: "mt-1 mb-1",
        attrs: {
          title: _vm.viewCounterMessage,
          type: "info",
          "is-simple-alerte": false,
          "is-mini": true,
        },
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }